import styled from "styled-components";
import { QuoteAltRight } from "@styled-icons/boxicons-solid/QuoteAltRight";
import { QuoteAltLeft } from "@styled-icons/boxicons-solid/QuoteAltLeft";

const Wrapper = styled.div``;

const QuoteRight = styled(QuoteAltRight)`
  height: 15px;
  margin-left: 5px;
`;

const QuoteLeft = styled(QuoteAltLeft)`
  height: 15px;
  margin-right: 5px;
`;

const Quote: React.FC<{ className?: string }> = ({ className, children }) => (
  <Wrapper className={className}>
    <QuoteRight />

    {children}

    <QuoteLeft />
  </Wrapper>
);

export default Quote;
